<template>
  <div style="width: 100%;">
          <span @click="closeTask" class="btn btn-secondary cursor-pointer float-right"
            v-if="isControlAssessment" qid="task-modal-close-icon">
            <font-awesome-icon icon="times" />
          </span>
          <span @click="minimizeTask" class="btn btn-secondary cursor-pointer float-right" v-else>
            <font-awesome-icon icon="window-minimize" />
          </span>
          <span @click="showEditQModal(selectedTask)" class="btn btn-secondary cursor-pointer float-right"
            v-if="isOwner(selectedTask)">
            <font-awesome-icon icon="cog" />
          </span>
          <h5 class="mb-1 text-center text-white"
            v-if="currentView != 'data_collection' && selectedTask && selectedTask.id && selectedTask.model && selectedTask.code != 'system_impact_assessment'">
            {{ selectedTask.full_title }}
          </h5>
          <h5 class="mb-1 text-center text-white"
            v-if="currentView == 'data_collection' && selectedTask && selectedTask.id && selectedTask.model && selectedTask.code != 'system_impact_assessment'">
            {{ selectedTask.full_title }}
          </h5>
          <h5 class="mb-1 text-center text-white"
            v-if="selectedTask && selectedTask.id && selectedTask.model && selectedTask.scope && selectedTask.code == 'system_impact_assessment'">
            {{ $t('system.assess_how') }}
            <span v-if="selectedTask.model.who_am_i == 'App\\System\\Models\\System'">
              {{ $t('system.the_system') }}
            </span>
            <span v-if="selectedTask.model.who_am_i == 'App\\Activity\\Models\\Activity'">
              {{ $t('system.the_activity') }}
            </span>
            <span v-if="selectedTask.model.who_am_i == 'App\\Process\\Models\\Process'">
              {{ $t('system.the_process') }}
            </span>
            <span v-if="selectedTask.model.who_am_i == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty'">
              {{ $t('system.the_contract') }}
            </span>
            <span v-if="selectedTask.model.who_am_i == 'App\\Maintenance\\Policy\\Models\\Policy'">
              {{ $t('system.the_policy') }}
            </span>
            <span class="breadcrumb-item">
              <a @click="navigateToTask(selectedTask)" :class="{ 'not-clickable': !isOwner(selectedTask.model) }">
                <font-awesome-icon icon="desktop" class="mr-1"
                  v-if="selectedTask.model.who_am_i == 'App\\System\\Models\\System'" />
                <font-awesome-icon icon="cubes" class="mr-1"
                  v-if="selectedTask.model.who_am_i == 'App\\Activity\\Models\\Activity'" />
                <font-awesome-icon icon="cube" class="mr-1"
                  v-if="selectedTask.model.who_am_i == 'App\\Process\\Models\\Process'" />
                <font-awesome-icon icon="file-signature" class="mr-1"
                  v-if="selectedTask.model.who_am_i == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty'" />
                <font-awesome-icon icon="file-invoice" class="mr-1"
                  v-if="selectedTask.model.who_am_i == 'App\\Maintenance\\Policy\\Models\\Policy'" />

                {{ selectedTask.model.name }}
              </a>
            </span>

            {{ $t('system.impacts') }}
            <span v-if="selectedTask.scope.who_am_i == 'App\\System\\Models\\System'">
              {{ $t('system.the_system') }}
            </span>
            <span v-if="selectedTask.scope.who_am_i == 'App\\Activity\\Models\\Activity'">
              {{ $t('system.the_activity') }}
            </span>
            <span v-if="selectedTask.scope.who_am_i == 'App\\Process\\Models\\Process'">
              {{ $t('system.the_process') }}
            </span>
            <span v-if="selectedTask.scope.who_am_i == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty'">
              {{ $t('system.the_contract') }}
            </span>
            <span v-if="selectedTask.scope.who_am_i == 'App\\Maintenance\\Policy\\Models\\Policy'">
              {{ $t('system.the_policy') }}
            </span>
            <span class="breadcrumb-item">
              <a @click="navigateToTaskScope(selectedTask)" :class="{ 'not-clickable': !isOwner(selectedTask.scope) }">
                <font-awesome-icon icon="desktop" class="mr-1"
                  v-if="selectedTask.scope.who_am_i == 'App\\System\\Models\\System'" />
                <font-awesome-icon icon="cubes" class="mr-1"
                  v-if="selectedTask.scope.who_am_i == 'App\\Activity\\Models\\Activity'" />
                <font-awesome-icon icon="cube" class="mr-1"
                  v-if="selectedTask.scope.who_am_i == 'App\\Process\\Models\\Process'" />
                <font-awesome-icon icon="file-signature" class="mr-1"
                  v-if="selectedTask.scope.who_am_i == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty'" />
                <font-awesome-icon icon="file-invoice" class="mr-1"
                  v-if="selectedTask.scope.who_am_i == 'App\\Maintenance\\Policy\\Models\\Policy'" />

                {{ selectedTask.scope.name }}
              </a>
            </span>
          </h5>

          <!-- Header text Types-->

          <div class="row mt-3 pt-4 pb-1"
            v-if="selectedTask && selectedTask.id && selectedTask.code != 'update_measures'">
            <div class="col-md-12"
              v-if="(isOwner(selectedTask.project) || isOwner(selectedTask)) && currentView == 'data_collection'">
              <span class="text-success breadcrumb-item cursor-pointer" @click="switchCurrentView('default')">
                <font-awesome-icon icon="angle-left" class="mr-1" />
                {{ $t('tasks.modal.back_to_main_task') }}
              </span>
            </div>
            <div class="col-sm-6" v-if="selectedTask.scope.name">
              <b-form-group>
                <div class="">


                  <label qid="task-name" v-if="selectedTask.code == 'system_impact_assessment'">
                    {{ $t('tasks.modal.system_impact_title') }}
                  </label>
                  <div v-if="selectedTask.code == 'system_impact_assessment'" class="text-formatted">
                    <span v-if="selectedTask.scope.who_am_i == 'App\\Process\\Models\\Process'">
                      {{ $t('tasks.modal.system_impact_description_process') }}
                    </span>
                    <span v-if="selectedTask.scope.who_am_i == 'App\\Activity\\Models\\Activity'">
                      {{ $t('tasks.modal.system_impact_description_activity') }}
                    </span>
                  </div>

                  <!-- Type 1 main task-->
                  <div v-if="selectedTask.code != 'system_impact_assessment' && currentView != 'data_collection'">
                    <div v-if="selectedTask.description && selectedTask.description.length > 300">
                      <p v-if="showFullMainTaskDescriptionOne" class="text-formatted">
                        {{ selectedTask.description }}
                      </p>
                      <p v-if="!showFullMainTaskDescriptionOne" class="text-formatted">
                        {{ selectedTask.description | truncate(300) }}
                      </p>
                      <div class="text-center mt-3"
                        @click="showFullMainTaskDescriptionOne = !showFullMainTaskDescriptionOne">
                        <span class="cursor-pointer" v-if="!showFullMainTaskDescriptionOne">
                          <span class="mr-2">
                            {{ $t('system.view_more') }}
                          </span>
                          <font-awesome-icon icon="chevron-down" class="text-white" />
                        </span>
                        <span class="cursor-pointer" v-if="showFullMainTaskDescriptionOne">
                          <span class="mr-2">
                            {{ $t('system.view_less') }}
                          </span>
                          <font-awesome-icon icon="chevron-up" class="text-white" />
                        </span>
                      </div>
                    </div>
                    <p v-if="selectedTask.description && selectedTask.description.length <= 300" class="text-formatted">
                      {{ selectedTask.description }}
                    </p>
                  </div>

                  <!-- Type 1 documentation task -->
                  <div v-if="selectedTask.code != 'system_impact_assessment' && currentView == 'data_collection'">
                    <div
                      v-if="selectedTask.data_collection_description && selectedTask.data_collection_description.length > 300">
                      <p v-if="showFullMainTaskDescriptionOne" class="text-formatted">
                        {{ selectedTask.data_collection_description }}
                      </p>
                      <p v-if="!showFullMainTaskDescriptionOne" class="text-formatted">
                        {{ selectedTask.data_collection_description | truncate(300) }}
                      </p>
                      <div class="text-center mt-3"
                        @click="showFullMainTaskDescriptionOne = !showFullMainTaskDescriptionOne">
                        <span class="cursor-pointer" v-if="!showFullMainTaskDescriptionOne">
                          <span class="mr-2">
                            {{ $t('system.view_more') }}
                          </span>
                          <font-awesome-icon icon="chevron-down" class="text-white" />
                        </span>
                        <span class="cursor-pointer" v-if="showFullMainTaskDescriptionOne">
                          <span class="mr-2">
                            {{ $t('system.view_less') }}
                          </span>
                          <font-awesome-icon icon="chevron-up" class="text-white" />
                        </span>
                      </div>
                    </div>
                    <p v-if="selectedTask.data_collection_description && selectedTask.data_collection_description.length <= 300"
                      class="text-formatted">
                      {{ selectedTask.data_collection_description }}
                    </p>
                  </div>


                </div>

                <!-- Question media -->
                <div class="mt-2 mb-1" v-if="getMedia('question') && currentView != 'data_collection'">
                  <p v-for="(file, media_index) in getMedia('question')" :key="media_index">
                    <span class="mr-3 float-right text-muted cursor-pointer" @click="downloadMedia(file)"
                      qid="download-media">
                      <font-awesome-icon icon="cloud-download-alt" />
                    </span>
                    <a @click="downloadMedia(file)" qid="create-p-media-item">
                      {{ file.file_name }}
                    </a>
                  </p>
                </div>
                <div class="mt-2 mb-1" v-if="getMedia('data_collection') && currentView == 'data_collection'">
                  <p v-for="(file, media_index) in getMedia('data_collection')" :key="media_index">
                    <span class="mr-3 float-right text-muted cursor-pointer" @click="downloadMedia(file)"
                      qid="download-media">
                      <font-awesome-icon icon="cloud-download-alt" />
                    </span>
                    <a @click="downloadMedia(file)" qid="create-p-media-item">
                      {{ file.file_name }}
                    </a>
                  </p>
                </div>

                <div class="" v-if="getLinks('question') && currentView != 'data_collection'">
                  <p v-for="(link, link_index) in getLinks('question')" :key="link_index">
                    <a :href="link.url" target="_blank" qid="create-p-link-item">
                      {{ link.name ? link.name : link.url }}
                    </a>
                  </p>
                </div>
                <div class="" v-if="getLinks('data_collection') && currentView == 'data_collection'">
                  <p v-for="(link, link_index) in getLinks('data_collection')" :key="link_index">
                    <a :href="link.url" target="_blank" qid="create-p-link-item">
                      {{ link.name ? link.name : link.url }}
                    </a>
                  </p>
                </div>
              </b-form-group>

            </div>
            <!-- Type 2 main task -->
            <div
              :class="{ 'col-sm-6': selectedTask.scope && selectedTask.scope.name, 'col-sm-12': !selectedTask.scope }">
              <b-form-group>
                <div class="">
                  <span class="btn btn-secondary btn-xs float-right cursor-pointer" @click="openWelcomePage()"
                    v-if="welcomeGuide && welcomeGuide.id">
                    <font-awesome-icon icon="eye" />
                    {{ $t('system.welcome_page_button') }}
                  </span>
                  <div
                    v-if="selectedTask.code != 'system_impact_assessment' && selectedTask.project && selectedTask.project.project_type == 'type two' && currentView != 'data_collection'">
                    <div v-if="selectedTask.description_two && selectedTask.description_two.length > 300">
                      <p v-if="showFullMainTaskDescriptionTwo" class="text-formatted">
                        {{ selectedTask.description_two }}
                      </p>
                      <p v-if="!showFullMainTaskDescriptionTwo" class="text-formatted">
                        {{ selectedTask.description_two | truncate(300) }}
                      </p>
                      <div class="text-center mt-3"
                        @click="showFullMainTaskDescriptionTwo = !showFullMainTaskDescriptionTwo">
                        <span class="cursor-pointer" v-if="!showFullMainTaskDescriptionTwo">
                          <span class="mr-2">
                            {{ $t('system.view_more') }}
                          </span>
                          <font-awesome-icon icon="chevron-down" class="text-white" />
                        </span>
                        <span class="cursor-pointer" v-if="showFullMainTaskDescriptionTwo">
                          <span class="mr-2">
                            {{ $t('system.view_less') }}
                          </span>
                          <font-awesome-icon icon="chevron-up" class="text-white" />
                        </span>
                      </div>
                    </div>
                    <p v-if="selectedTask.description_two && selectedTask.description_two.length <= 300"
                      class="text-formatted">
                      {{ selectedTask.description_two }}
                    </p>
                  </div>
                  <div
                    v-if="selectedTask.code != 'system_impact_assessment' && selectedTask.project && selectedTask.project.project_type == 'type two' && currentView == 'data_collection'">
                    <div
                      v-if="selectedTask.data_collection_description_two && selectedTask.data_collection_description_two.length > 300">
                      <p v-if="showFullMainTaskDescriptionTwo" class="text-formatted">
                        {{ selectedTask.data_collection_description_two }}
                      </p>
                      <p v-if="!showFullMainTaskDescriptionTwo" class="text-formatted">
                        {{ selectedTask.data_collection_description_two | truncate(300) }}
                      </p>
                      <div class="text-center mt-3"
                        @click="showFullMainTaskDescriptionTwo = !showFullMainTaskDescriptionTwo">
                        <span class="cursor-pointer" v-if="!showFullMainTaskDescriptionTwo">
                          <span class="mr-2">
                            {{ $t('system.view_more') }}
                          </span>
                          <font-awesome-icon icon="chevron-down" class="text-white" />
                        </span>
                        <span class="cursor-pointer" v-if="showFullMainTaskDescriptionTwo">
                          <span class="mr-2">
                            {{ $t('system.view_less') }}
                          </span>
                          <font-awesome-icon icon="chevron-up" class="text-white" />
                        </span>
                      </div>
                    </div>
                    <p v-if="selectedTask.data_collection_description_two && selectedTask.data_collection_description_two.length <= 300"
                      class="text-formatted">
                      {{ selectedTask.data_collection_description_two }}
                    </p>
                  </div>
                  <div
                    v-if="getGuide('assessment_task') && currentView == 'default' && selectedTask.code != 'update_measures'"
                    style="margin-top:20px;">
                    <span class="btn btn-secondary btn-xs float-right cursor-pointer" @click="openGuide()">
                      <font-awesome-icon icon="eye" />
                      {{ $t('administration.guide.modal.button') }}
                    </span>

                    <label qid="create-p-users-label"
                      v-if="selectedTask.project && selectedTask.project.schedule_message">
                      {{ $t('tasks.modal.project_message_label') }}
                    </label>
                    <div class="" v-if="selectedTask.project && selectedTask.project.schedule_message">
                      <p>
                        {{ selectedTask.project.schedule_message }}
                      </p>
                    </div>

                    <label qid="create-p-users-label">
                      {{ $t('system.help_center_label') }}
                    </label>
                    <div v-if="wpGuide && wpGuide.id" class="guide-content-container">
                      <p v-if="!showFullGuideDescription" v-html="wpGuide.excerpt.rendered"></p>
                      <p v-if="showFullGuideDescription" v-html="wpGuide.content.rendered"></p>

                      <div class="text-center mt-3" @click="showFullGuideDescription = !showFullGuideDescription">
                        <span class="cursor-pointer" v-if="!showFullGuideDescription">
                          <span class="mr-2">
                            {{ $t('system.view_more') }}
                          </span>
                          <font-awesome-icon icon="chevron-down" />
                        </span>
                        <span class="cursor-pointer" v-if="showFullGuideDescription">
                          <span class="mr-2">
                            {{ $t('system.view_less') }}
                          </span>
                          <font-awesome-icon icon="chevron-up" />
                        </span>
                      </div>
                    </div>
                  </div>

                  <!-- Data collection guide -->
                  <div v-if="getGuide('data_collection_task') && currentView == 'data_collection'"
                    style="margin-top:20px;">
                    <span class="btn btn-secondary btn-xs float-right cursor-pointer" @click="openGuide()">
                      <font-awesome-icon icon="eye" />
                      {{ $t('administration.guide.modal.button') }}
                    </span>

                    <label qid="create-p-users-label"
                      v-if="selectedTask.project && selectedTask.project.schedule_message">
                      {{ $t('tasks.modal.project_message_label') }}
                    </label>
                    <div class="" v-if="selectedTask.project && selectedTask.project.schedule_message">
                      <p>
                        {{ selectedTask.project.schedule_message }}
                      </p>
                    </div>

                    <label qid="create-p-users-label">
                      {{ $t('system.help_center_label') }}
                    </label>
                    <div v-if="wpGuideData && wpGuideData.id" class="guide-content-container">
                      <p v-if="!showFullGuideDescription" v-html="wpGuideData.excerpt.rendered"></p>
                      <p v-if="showFullGuideDescription" v-html="wpGuideData.content.rendered"></p>

                      <div class="text-center mt-3" @click="showFullGuideDescription = !showFullGuideDescription">
                        <span class="cursor-pointer" v-if="!showFullGuideDescription">
                          <span class="mr-2">
                            {{ $t('system.view_more') }}
                          </span>
                          <font-awesome-icon icon="chevron-down" />
                        </span>
                        <span class="cursor-pointer" v-if="showFullGuideDescription">
                          <span class="mr-2">
                            {{ $t('system.view_less') }}
                          </span>
                          <font-awesome-icon icon="chevron-up" />
                        </span>
                      </div>
                    </div>
                  </div>

                  <!-- System description guide -->
                  <div
                    v-if="getGuide('system_description_task') && currentView == 'default' && selectedTask.code == 'update_measures'"
                    style="margin-top:20px;">
                    <span class="btn btn-secondary btn-xs float-right cursor-pointer" @click="openGuide()">
                      <font-awesome-icon icon="eye" />
                      {{ $t('administration.guide.modal.button') }}
                    </span>

                    <label qid="create-p-users-label"
                      v-if="selectedTask.project && selectedTask.project.schedule_message">
                      {{ $t('tasks.modal.project_message_label') }}
                    </label>
                    <div class="" v-if="selectedTask.project && selectedTask.project.schedule_message">
                      <p>
                        {{ selectedTask.project.schedule_message }}
                      </p>
                    </div>

                    <label qid="create-p-users-label">
                      {{ $t('system.help_center_label') }}
                    </label>
                    <div v-if="wpGuideSystem && wpGuideSystem.id" class="guide-content-container">
                      <p v-if="!showFullGuideDescription" v-html="wpGuideSystem.excerpt.rendered"></p>
                      <p v-if="showFullGuideDescription" v-html="wpGuideSystem.content.rendered"></p>

                      <div class="text-center mt-3" @click="showFullGuideDescription = !showFullGuideDescription">
                        <span class="cursor-pointer" v-if="!showFullGuideDescription">
                          <span class="mr-2">
                            {{ $t('system.view_more') }}
                          </span>
                          <font-awesome-icon icon="chevron-down" />
                        </span>
                        <span class="cursor-pointer" v-if="showFullGuideDescription">
                          <span class="mr-2">
                            {{ $t('system.view_less') }}
                          </span>
                          <font-awesome-icon icon="chevron-up" />
                        </span>
                      </div>
                    </div>
                  </div>

                </div>
                <div class="mt-2 mb-1" v-if="getReportMedia && getReportMedia.length">
                  <p v-for="(file, media_index) in getReportMedia" :key="media_index">
                    <span class="mr-3 float-right text-muted cursor-pointer" @click="downloadMedia(file)"
                      qid="download-media">
                      <font-awesome-icon icon="cloud-download-alt" />
                    </span>
                    <a @click="downloadMedia(file)" qid="create-p-media-item">
                      {{ file.file_name }}
                    </a>
                  </p>
                </div>

                <div class="" v-if="getReportLinks && getReportLinks.length">
                  <p v-for="(link, link_index) in getReportLinks" :key="link_index">
                    <a :href="link.url" target="_blank" qid="create-p-link-item">
                      {{ link.name ? link.name : link.url }}
                    </a>
                  </p>
                </div>
              </b-form-group>
            </div>
          </div>
        </div>
  </div>
</template>

<script>
import assessmentSingleTaskProxy from './assessmentSingleTaskProxy';

export default {
  name: 'AssessmentGlobalSingleTaskModalHeader',
  mixins: [assessmentSingleTaskProxy]
};
</script>
